<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-layer-group"></i>
        설정
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">시스템</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">설정</a>
        </li>
      </ul>
    </div>
    <!-- 시스템 설정임 -->
    <b-card no-body border-variant="warning">
      <b-tabs class="" v-model="index" content-class="mt-3" fill justified>
        <b-tab :title="'라이선스'" active v-if="model.license.code">
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              라이선스
            </div>
          </div>
          <hr>
          <div class="row mb-2">
            <div class="col-xl-12 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="Company">
                F1-UWSS 저작권, 만기일 :
                <span class="text-danger px-2">{{model.license.data.summary.expire | datetime}}</span>
                설정을 변경한다면, 최소 30분 후부터 적용이 됩니다.
              </label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="OnPremise">
                온프레미스
              </label>
            </div>
            <div class="col-xl-10 col-md-12 d-flex align-self-center">
              <div class="checkbox-switch">
                  <input type="checkbox" class="input-checkbox" name="OnPremise" id="OnPremise" checked="" :disabled="true" v-if="model.license.data.summary.Group" v-model="model.license.data.summary.Group.use" />
                  <div class="checkbox-animate disabled">
                      <span class="checkbox-off">OFF</span>
                      <span class="checkbox-on">ON</span>
                  </div>
              </div>
              <div class="ml-2">* 온프레미스를 사용한다면, 청구서를 발행하거나 결제를 자동으로 지불할 수 없습니다.</div>
            </div>
          </div>
          <hr>
          <b-row v-if="model.license.data.summary.Group">
            <b-col md="2" class="col-form-label" for="Group"> 그룹 <small>(최대)</small> </b-col>
              <b-col md="1" class="col-xl-1 col-md-12 d-flex align-self-center">
                <!-- <c-switch :disabled="true" v-if="model.license.data.summary.Group" color="info" label v-model="model.license.data.summary.Group.use" /> -->
                <div class="checkbox-switch">
                  <input type="checkbox" class="input-checkbox" name="Group" id="Group" checked="" :disabled="true" v-if="model.license.data.summary.Group" v-model="model.license.data.summary.Group.use" />
                  <div class="checkbox-animate disabled">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                  </div>
                </div>
              </b-col>
              <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.Group" v-model="model.license.data.summary.Group.qty"></b-input></b-col>
              <b-col md="2" class="col-form-label" for="Group"> 사용자 <small>(최대)</small> </b-col>
              <b-col md="1" class="col-xl-1 col-md-12 d-flex align-self-center">
                <!-- <c-switch :disabled="true" v-if="model.license.data.summary.User" color="info" label v-model="model.license.data.summary.User.use" /> -->
                <div class="checkbox-switch">
                  <input type="checkbox" class="input-checkbox" name="User" id="User" checked="" :disabled="true" v-if="model.license.data.summary.User" v-model="model.license.data.summary.User.use" />
                  <div class="checkbox-animate disabled">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                  </div>
                </div>
              </b-col>
            <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.User" v-model="model.license.data.summary.User.qty"></b-input></b-col>
          </b-row>
          <hr>
          <b-row v-if="model.license">
            <b-col md="2" class="col-form-label" for="WSFinder"> WSFinder <small>(최대)</small> </b-col>
            <b-col md="1" class="col-xl-1 col-md-12 d-flex align-self-center">
              <!-- <c-switch :disabled="true" v-if="model.license.data.summary.WSFinder" color="info" label v-model="model.license.data.summary.WSFinder.use" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="WSFinder" id="WSFinder" checked="" :disabled="true" v-if="model.license.data.summary.WSFinder" v-model="model.license.data.summary.WSFinder.use" />
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.WSFinder" v-model="model.license.data.summary.WSFinder.qty"></b-input></b-col>
            <b-col md="2" class="col-form-label" for="WEBCastle"> WEBCastle <small>(최대)</small> </b-col>
            <b-col md="1" class="col-xl-1 col-md-12 d-flex align-self-center">
              <!-- <c-switch :disabled="true" v-if="model.license.data.summary.WEBCastle" color="info" label v-model="model.license.data.summary.WEBCastle.use" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="WEBCastle" id="WEBCastle" checked="" :disabled="true" v-if="model.license.data.summary.WEBCastle" v-model="model.license.data.summary.WEBCastle.use" />
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.WEBCastle" v-model="model.license.data.summary.WEBCastle.qty"></b-input></b-col>
          </b-row>
          <hr>
          <b-row v-if="model.license">
            <b-col md="2" class="col-form-label" for="WMDS"> WMDS <small>(최대)</small> </b-col>
            <b-col md="1" class="col-xl-1 col-md-12 d-flex align-self-center">
              <!-- <c-switch :disabled="true" v-if="model.license.data.summary.WMDS" color="info" label v-model="model.license.data.summary.WMDS.use" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="WMDS" id="WMDS" checked="" :disabled="true" v-if="model.license.data.summary.WMDS" v-model="model.license.data.summary.WMDS.use" />
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.WMDS" v-model="model.license.data.summary.WMDS.qty"></b-input></b-col>
            <b-col md="2" class="col-form-label" for="WFDetector"> WFDetector <small>(최대)</small> </b-col>
            <b-col md="1" class="col-xl-1 col-md-12 d-flex align-self-center">
              <!-- <c-switch :disabled="true" v-if="model.license.data.summary.WFDetect" color="info" label v-model="model.license.data.summary.WFDetect.use" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="WFDetector" id="WFDetector" checked="" :disabled="true" v-if="model.license.data.summary.WFDetect" v-model="model.license.data.summary.WFDetect.use" />
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.WEBCastle" v-model="model.license.data.summary.WEBCastle.qty"></b-input></b-col>
          </b-row>
          <hr>
          <b-row class="mb-3">
            <b-col class="col-xl-2 col-md-12 col-form-label">
              언어
            </b-col>
            <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
              <select class="form-control" v-model="model.license.data.info.language">
                <option disabled value="">언어를 선택하세요.</option>
                <option value="EN">영어</option>
                <option value="KO">한국어</option>
              </select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2" class="col-form-label"><span>사이트 라이선스</span></b-col>
            <b-col md="8"><b-input :type="toggle" v-model="model.license.data.info.key" placeholder="ex) UWSS 플랫폼을 위한 라이선스 키를 입력하세요." ></b-input></b-col>
            <b-col md="2">
              <b-button block class="btn btn-cancel" type="button" @click="toggle = toggle == 'password' ? 'text' : 'password';">{{toggle == 'password' ? '보여주기' : '숨기기'}}</b-button>
            </b-col>
          </b-row>
          <!-- <div class="row mb-2 mt-2">
            <div class="col-xl-12 col-md-12">
              <div class="text-center">
                <button type="button" @click="confirm_save = true; type = 'license'" class="btn btn-add col-xl-2 mr-2">
                  적용
                </button>
                <button type="button" class="btn btn-cancel col-xl-2" @click="toggle = toggle == 'password' ? 'text' : 'password';">
                  {{toggle == 'password' ? '보여주기' : '숨기기'}}
                </button>
              </div>
            </div>
          </div> -->
          <hr>
          <b-row>
            <b-col md="2" class="col-form-label"><span>URL 인증 라이선스</span></b-col>
            <b-col md="10"><b-input type="text" v-model="model.license.data.info.url" placeholder="ex) 인증할 서버의 URL 을 입력하세요." ></b-input></b-col>
            <!-- <b-col md="2">
              <b-button block variant="danger" type="button" @click="confirm_save = true; type = 'license'">적용</b-button>
            </b-col> -->
          </b-row>
          <hr>
          <b-button block variant="danger" type="button" @click="confirm_save = true; type = 'license'">적용</b-button>
        </b-tab>
        <!-- 메일설정 -->
        <b-tab :title="'메일'" v-if="model.mail.code">
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              메일
            </div>
          </div>
          <hr>
          <b-row>
            <b-col class="col-form-label" for="From"><span>받는 사람</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center"><b-input v-model="model.mail.data.from" placeholder="ex) f1uwss@f1security.co.kr" ></b-input></b-col>

            <b-col class="col-form-label" for="Username"><span>사용자명</span></b-col>
            <b-col class="col-xl-4 col-md-12"><b-input v-model="model.mail.data.username" placeholder="ex) SMTP을 위한 사용자명" ></b-input></b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Password"><span>비밀번호</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center"><b-input type="password" v-model="model.mail.data.password" placeholder="ex) SMTP을 위한 비밀번호" ></b-input></b-col>
            
            <b-col class="col-form-label" for="PORT"><span>포트 번호</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center"><b-input v-model="model.mail.data.port" placeholder="ex) 587" ></b-input></b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col class="col-form-label" for="SMTP_Server"><span>SMTP 서버</span></b-col>
            <b-col class="col-xl-10 col-md-12 d-flex align-self-center"><b-input v-model="model.mail.data.server" placeholder="ex) smtp.main.org" ></b-input></b-col>
          </b-row>
          <hr>
          <b-button variant="danger" type="button" block @click="confirm_save = true; type = 'mail'">저장</b-button>
        </b-tab>
        <b-tab no-body :title="'룰'" v-if="model.rule.code">
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              룰
            </div>
          </div>
          <hr>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              WMDS
            </div>
          </div>
          <!-- WMDS -->
          <b-row>
            <b-col class="col-form-label" for="Init"><span>초기화</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <!-- <c-switch color="info" label v-model="model.rule.data.wmds.init" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Init" id="Init" checked="" v-model="model.rule.data.wmds.init" />
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>

            <b-col class="col-form-label" for="Status"><span>상태</span></b-col>
            <b-col class="col-xl-4 col-md-12">
              <!-- <c-switch color="info" label v-model="model.rule.data.wmds.is_run" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Status" id="Status" v-model="model.rule.data.wmds.is_run" />
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Point"><span>포인트 : 체크 포인트</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center"><b-input v-model="model.rule.data.wmds.cp" placeholder="ex) 패턴 업데이트 체크 포인트" ></b-input></b-col>

            <b-col class="col-form-label" for="Rule_Server"><span>룰 서버</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center"><b-input v-model="model.rule.data.wmds.url" placeholder="ex) 룰 업데이트 원격 서버" ></b-input></b-col>
          </b-row>
          <hr>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              WSFinder
            </div>
          </div>
          <!-- WSFinder -->
          <b-row>
            <b-col class="col-form-label" for="Init"><span>초기화</span></b-col>
            <b-col class="col-xl-4 col-md-12">
              <!-- <c-switch color="info" label v-model="model.rule.data.wsfinder.init" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Init" id="Init" v-model="model.rule.data.wsfinder.init" />
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col class="col-form-label" for="Status"><span>상태</span></b-col>
            <b-col class="col-xl-4 col-md-12">
              <!-- <c-switch color="info" label v-model="model.rule.data.wsfinder.is_run" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Status" id="Status" v-model="model.rule.data.wsfinder.is_run">
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Point"><span>포인트 : 체크 포인트</span></b-col><!--cp-->
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center"><b-input v-model="model.rule.data.wsfinder.cp" placeholder="ex) 패턴 업데이트 체크 포인트" ></b-input></b-col>

            <b-col class="col-form-label" for="Rule_Server"><span>룰 서버</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center"><b-input v-model="model.rule.data.wsfinder.url" placeholder="ex) 룰 업데이트 원격 서버" ></b-input></b-col>
          </b-row>
          <hr>
          <b-button variant="danger" type="button" block @click="confirm_save = true; type = 'rule'">저장</b-button>
        </b-tab>
        <!-- 로고 -->
        <!-- <b-tab :title="model.logo.code.toUpperCase()" active v-if="model.logo && model.logo.code"> -->
        <b-tab :title="'커스텀'" active v-if="model.logo && model.logo.code">
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              커스텀
            </div>
          </div>
          <hr>
          <b-row>
            <b-col class="col-form-label" for="Slogan">
              슬로건
            </b-col>
            <b-col md="10">
              <b-input v-model="model.logo.data.slogan" placeholder="ex) F1-UWSS" ></b-input>
              <br>
              <small>* 사용자가 로그인한 화면에 표시되는 로고를 설정할 수 있습니다.</small>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Business_Number">
              로고
            </b-col>
            <b-col md="10">
              <picture-input
                :z-index="2"
                radius="3"
                :prefill="model.logo.data.image"
                v-show="!confirm_save && !confirm_refresh"
                ref="pictureInput"
                height="150" min-height="150" width="800" max-width="800" max-height="800"
                accept="image/*" size="2" button-class="btn btn-dark"
                :custom-strings="{
                  upload: '<h1>test!</h1>',
                  drag: '<small>Drag & Drop<small>',
                }"
                @change="logo_change">
              </picture-input>
              <br>
              <small>* 사용자가 로그인한 화면에 표시되는 로그인 슬로건을 설정할 수 있습니다.  <span class='text-danger'>(최소 권장 사이즈 : 800px X 200px)</span> </small>
              <b-button size="sm" class="m-1 float-right" variant="warning" @click="model.logo.data.image = ''">Clear</b-button>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Logo_favicon_ico">
              로고 favicon.ico
              <b-badge variant="danger" v-if="favicon">Using</b-badge>
            </b-col>
            <b-col md="10" class="text-center">
              <p v-if="!favicon">
                <b-form-file
                placeholder="파일 선택하거나 여기로 끌고오세요."
                @input="input_favicon"
                ></b-form-file>
              </p>
              <b-img v-else :src="favicon"></b-img>
              <hr>
              <small>* favicon은 바로 가기 아이콘, 웹 사이트 아이콘, 탭 아이콘, URL 아이콘 또는 책갈피 아이콘입니다.  <span class='text-danger'>(최소 권장 사이즈 : 800px X 200px)</span> </small>
              <b-button size="sm" class="m-1 float-right" variant="warning" @click="favicon = ''">Clear</b-button>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label">
              다른 이메일
              <br>
              <small>(모두 참조)</small>
            </b-col>
            <b-col md="10">
              <b-input v-model="model.logo.data.support" placeholder="ex) support@f1security.co.kr,uwss@f1security.co.kr" ></b-input>
              <br>
              <small>* 비밀번호 찾기 등 인증 관련 메일은 기술지원을 위한 모든 메일 안내 참조</small>
              <br>
              <small>[ex) admin@f1security.co.kr,support@f1secuirty.co.kr...]</small>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Maual_URL">
              메뉴얼 URL
            </b-col>
            <b-col class="col-xl-4 col-md-12 align-self-center">
              <b-input v-model="model.logo.data.manual" placeholder="ex) https://f1security.co.kr/manual.pdf" ></b-input>
              <br>
              <small>* 기본값은 F1-UWSS 수동 URL입니다. <br>(<b-button variant="link" @click="redirect_manual()">{{this.ko_manual}}</b-button>)</small>
            </b-col>
            <b-col class="col-form-label" for="Help_Email">
              도움말 이메일
            </b-col>
            <b-col class="col-xl-4 col-md-12 align-self-center">
              <b-input v-model="model.logo.data.help" placeholder="ex) help@uwss.kr" ></b-input>
              <br>
              <small>최종 고객, 파트너에게 공개 회신을 알리는 메일 주소입니다. 설정한 메일을 통해 사용자들의 문의를 받게 됩니다.</small>
            </b-col>
          </b-row>
          <!-- <hr> -->
          <!-- <b-row>
            <b-col md="2">
              Address
            </b-col>
            <b-col md="10">
              <b-input v-model="model.logo.data.address" placeholder="ex) #1402, 234, Beotkkot-ro, Geumcheon-gu, Seoul, Republic of Korea." ></b-input>
              <br>
              <small>This address will be shown in the mail</small>
            </b-col>
          </b-row> -->
          <hr>
          <b-button v-if="model.invoice.data && model.invoice.data.image" block variant="primary" type="button" @click="clear_logo">초기화</b-button>
          <b-button block variant="danger" type="button" @click="confirm_save = true; type = 'logo'">적용</b-button>
        </b-tab>
        <!-- 인보이스 -->
        <b-tab :title="'청구서'" active v-if="model.invoice && model.invoice.code">
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              청구서
            </div>
          </div>
          <hr>
          <b-row>
            <b-col class="col-form-label" for="Company">
              회사
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-input v-model="model.invoice.data.company" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
            <b-col class="col-form-label" for="Contact">
              컨텍트
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-input v-model="model.invoice.data.contact" placeholder="ex) +82 070-4640-3030" ></b-input>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col class="col-form-label" for="Business_Number">
              사업 번호
            </b-col>
            <b-col class="col-xl-10 col-md-12 d-flex align-self-center">
              <b-input v-model="model.invoice.data.business_number" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col class="col-form-label" for="Address">
              주소
            </b-col>
            <b-col class="col-xl-10 col-md-12 d-flex align-self-center">
              <b-input v-model="model.invoice.data.company_address" placeholder="ex) F1 Security office location" ></b-input>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col class="col-form-label" for="Issuer">
              발급사
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-input v-model="model.invoice.data.issuer" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
            <b-col class="col-form-label" for="Issuer_Email">
              발급사 이메일
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-input v-model="model.invoice.data.issuer_email" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col class="col-form-label" for="Bank_Name">
              은행명
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-input v-model="model.invoice.data.bank_name" placeholder="ex) F1security Bank" ></b-input>
            </b-col>
            <b-col class="col-form-label" for="Bank_Number">
              은행 번호
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-input v-model="model.invoice.data.bank_number" placeholder="ex) -" ></b-input>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col md="2">
              은행 Swift 코드
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-input v-model="model.invoice.data.swift_code"></b-input>
            </b-col>
            <b-col class="col-form-label" for="Account_Holder">
              계정 소유자
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-input v-model="model.invoice.data.account_holder" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col class="col-form-label" for="Bank_branch">
              은행 지점
            </b-col>
            <b-col class="col-xl-10 col-md-12 d-flex align-self-center">
              <b-input v-model="model.invoice.data.bank_branch"></b-input>
            </b-col>
          </b-row>
          <div class="row mb-2">
            <div class="col-xl-12 col-md-12 d-flex align-self-center">
              * 이 정보는 플랫폼에서 청구서가 발행될 때 표시됩니다.
            </div>
          </div>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Issue_Day">
              발행일
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-input type="number" v-model="model.invoice.data.issue_day" placeholder="기본 1일" ></b-input>
            </b-col>
            <div class="col-xl-6 col-md-12 d-flex align-self-center">
              청구서 발행일 선택
            </div>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Pay_Day">
              지불일
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-input type="number" v-model="model.invoice.data.pay_day" placeholder="기본 5일" ></b-input>
            </b-col>
            <div class="col-xl-6 col-md-12 d-flex align-self-center">
              예금으로 발행된 청구서의 자동 지급 날짜를 지정합니다.
            </div>
          </b-row>

          <hr>
          <b-button v-if="model.invoice.data && model.invoice.data.image" block variant="primary" type="button" @click="clear_logo">초기화</b-button>
          <b-button block variant="danger" type="button" @click="confirm_save = true; type = 'invoice'">적용</b-button>
        </b-tab>
      </b-tabs>
    </b-card>

    <!-- 시스템의 기본 서비스 관리 추가 -->
    <ServiceList />
    <!-- <b-card border-variant="primary" id="list">
      <template slot="header">
        <i class='fa fa-align-justify'></i> UWSS Base Service
      </template>
      <b-row>
        <b-col md="9">
          <h4>
            <b-badge variant="danger">* Notice</b-badge>
          </h4>
          - Newly created services are available to partners after the system is created.
        </b-col>
        <b-col md="3">
          <b-button size="sm" variant="success" class="pull-right mx-1" @click="service_new = true; confirm_info = true; service = {}"> New Registration </b-button>
          <b-button size="sm" variant="info" class="pull-right mx-1" @click="$refs._list.refresh()"> Refresh </b-button>
        </b-col>
      </b-row>
      <hr> -->



      <!-- <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="load_service" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="is_alive" slot-scope="row">
          <c-switch @change="status_change($event, row.item, 'is_alive')" color="warning" label v-model="row.item.status" />
        </template>
        <template slot="name" slot-scope="row">
          <b-btn @click="status_change(row.item, row.item, 'is_del')" variant="outline-danger" size="sm">Delete</b-btn>
          {{row.item.name}}
        </template>
        <template slot="list_price" slot-scope="row">{{row.item.list_price | dollar}}</template>
        <template slot="min_price" slot-scope="row">{{row.item.min_price | dollar}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">Select</b-btn>
        </template>
      </b-table> -->
    <!-- </b-card> -->

    <!-- 기존 파트너의 가격 수정 여부 확인 모달 -->
    <b-modal hide-footer title="시스템 서비스 가격 수정"  class="modal-warning" v-model="confirm_all">
      기존 파트너에게 새로운 가격을 적용하겠습니까?
      "가격만 업데이트"를 누르면 적용 후 생성된 계정은 업데이트된 가격의 영향을 받습니다.
      <b-button class="mt-3" variant="outline-warning" block @click="confirm_all = false; upsert_service()">새로운 가격만 등록</b-button>
      <b-button class="mt-3" variant="outline-danger" block @click="service.apply_all = true; upsert_service()">가격 적용</b-button>
    </b-modal>
    <!-- 미사용 확인 모달 -->
    <b-modal title="시스템 정보 업데이트"  class="modal-danger" header-bg-variant="danger" v-model="confirm_save" @ok="confirm_refresh = true" ok-variant="outline-danger"
    ok-title="확인" cancel-variant="outline-dark" cancel-title="취소">
      이 정보를 업데이트하시겠습니까?
    </b-modal>
    <!-- 적용을 위한 페이지 새로고침 안내 -->
    <b-modal title="시스템 새로고침 안내" header-bg-variant="warning" ok-only v-model="confirm_refresh" @ok="save" ok-variant="outline-warning" ok-title="확인">
      변경된 설정을 적용하려면 페이지 새로고침이 필요하며,
      <br>
      설정 적용 후 3초 후에 자동으로 새로고침됩니다.
      <br>
      걱정하지마세요.😉
    </b-modal>
    </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>